// Chain color mapping
export const CHAIN_COLORS: Record<string, string> = {
  'Ethereum': 'blue',
  'ETH': 'blue',
  'Avalanche': 'red',
  'AVAX': 'red',
  'Polygon': 'purple',
  'MATIC': 'purple',
  'Arbitrum': 'cyan',
  'ARB': 'cyan',
  'Optimism': 'orange',
  'OP': 'orange',
  'Base': 'teal',
  'BSC': 'yellow',
  'BNB': 'yellow',
  'Binance Smart Chain': 'yellow',
  'Fantom': 'pink',
  'FTM': 'pink',
  'Solana': 'green',
  'SOL': 'green',
  'Cardano': 'blue',
  'ADA': 'blue',
  'Polkadot': 'purple',
  'DOT': 'purple',
  'Cosmos': 'cyan',
  'ATOM': 'cyan',
  'Chainlink': 'blue',
  'LINK': 'blue'
};

// Helper function to get chain color
export const getChainColor = (chainName: string): string => {
  return CHAIN_COLORS[chainName] || 'gray';
};
